import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ModalContainerService, ModalService, UserService, BaseModalContainer } from 'yt-ng-framework';
import { VazeciProcenatZarade } from './vazeci-procenat-zarade';

@Component({
  selector: 'app-vazeci-procenat-zarade',
  templateUrl: './vazeci-procenat-zarade.component.html'
})
export class VazeciProcenatZaradeComponent extends BaseModalContainer<VazeciProcenatZarade>implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VazeciProcenatZarade>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
